//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isBasketActive: {
      type: Boolean,
    },
  },
  methods: {
    sendLoginEventToGTM() {
      this.$gtm?.push({
        event: 'autoEvent',
        eventCategory: 'click',
        eventAction: 'login',
        eventLabel: 'cursos_page',
      });
    },
    async logout() {
      this.debug({ name: 'logout' }, 'logout');
      document.cookie = `a_token=; path=/; domain=${window.location.hostname}; max-age=-1; secure`;
      await this.$store.dispatch('user/logoutFromLms');
      this.$app.user = null;
    },
  },
};
